<template>

    <v-container v-if="hotels" fluid>

      <im-page-title
        title="Listă Hoteluri"
      />

      <im-hotels-toolbar
        :query.sync="query"
      />

      <div class="ma-3">
        <v-progress-linear
          :indeterminate="querying"
          :color="querying ? 'primary' : 'grey'"
          rounded
        />
      </div>

      <im-hotels-list
        :hotels="hotels"
        :pagination.sync="pagination"
      />

    </v-container>

    <v-container v-else fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-progress-circular indeterminate color="primary"/>
      </v-row>
    </v-container>

</template>


<script>

  import _ from 'lodash';
  import repository from '@/repositories/hotel-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-hotels-toolbar': () => import('@/components/Hotels/HotelsToolbar'),
      'im-hotels-list': () => import('@/components/Hotels/HotelsList')
    },

    data: () => ({
      hotels: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchHotelsDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchHotels',
        immediate: false
      }
    },

    methods: {

      fetchHotelsDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchHotels()
      }, 300),

      async fetchHotels() {
        try {
          this.querying = true;
          this.hotels = await repository.getHotels(this.query, this.pagination);
        } catch (e) {
        } finally {
          this.querying = false;
        }
      }

    }
  }

</script>